  <app-running-line [background]="true" *ngIf="!mob"/>
  <div class="footer-container" [class]="themeService.getTheme()">
    <div class="footer-workspace" [style.background]="getBackground()">
      <app-running-line [background]="true" [footer]="true" *ngIf="mob"/>
      <div class="footer-workspace-top">
        <div class="footer-workspace-top-left col-9 footer-font" *ngIf="!mob">
          <app-texts
            [texts]="[
                {text: ['Office 4, 10/F Kwan Chart Tower, No. 6 Tonnochy Rd, Wan Chai, Hong Kong', 'Office 4, 10/F Kwan Chart Tower, No. 6 Tonnochy Rd, Wan Chai, Hong Kong'], transfer: true},
              ]"
          />
        </div>
        <div class="footer-workspace-top-right col-3 footer-font" [style]="'padding-left: 5vw'" *ngIf="!mob">
          <app-texts
            *ngIf="!mob"
            (click)="multiOpen(false, $event)"
            [texts]="topRight"
            style="display: flex"
          />
          <div class="footer-textapp" *ngIf="mob">
            <app-texts
              class="footer-textapp"
              *ngIf="mob"
              (click)="multiOpen(false, $event)"
              [texts]="[
        {text: ['Куки', 'Cookie Policy']}
      ]"
            />
            <app-texts
              class="footer-textapp"
              *ngIf="mob"
              (click)="multiOpen(false, $event)"
              [texts]="[
        {text: ['Приватность', 'Privacy Policy']}
      ]"
            />
            <app-texts
              class="footer-textapp"
              *ngIf="mob"
              (click)="multiOpen(false, $event)"
              [texts]="[
        {text: ['Оферта', 'Public Offer']}
      ]"
            />
          </div>
        </div>
        <div class="top-mob" *ngIf="mob">
          <div class="top-mob-el">
            <app-texts [texts]="[
            {text: ['BR № 77889104 ', 'BR № 77889104']}
          ]"/>
            <span>|</span>
            <app-texts [texts]="[
            {text: ['IATA TIDS 96223466', 'IATA TIDS 96223466']}
          ]"/>
          </div>
          <div class="top-mob-el" style="line-height: 20px; margin-top: 17px">
            <app-texts [texts]="[
            {text: ['Office 4, 10/F Kwan Chart Tower, No. 6 \n'+
'Tonnochy Rd, Wan Chai, Hong Kong ', 'Office 4, 10/F Kwan Chart Tower, No. 6 \n'+
'Tonnochy Rd, Wan Chai, Hong Kong']}
          ]"/>
          </div>
        </div>
      </div>
      <div class="footer-workspace-mid">
        <div class="footer-workspace-mid-left col-3  footer-middle-text" style="white-space: nowrap;">
          <div class="footer-font">
            <div class="footer-font-in footer-link">
              <app-texts
                [texts]="midRight1"
              />
              <div class="footer-font-in-click" (click)="openPdfInNewTab('cookie', $event)"></div>
            </div>
          </div>
          <div class="footer-font footer-link" style="padding: 23px 0">
            <div class="footer-font-in">
              <app-texts
                [texts]="midRight2"
              />
              <div class="footer-font-in-click" (click)="openPdfInNewTab('privacy', $event)"></div>
            </div>
          </div>
          <div class="footer-font footer-link">
            <div class="footer-font-in">
              <app-texts
                [texts]="midRight3"
              />
              <div class="footer-font-in-click" (click)="openPdfInNewTab('public', $event)"></div>
            </div>
          </div>
        </div>
        <div class="footer-workspace-mid-middle col-6">
          <div class="footer-workspace-mid-middle-text-container">
<!--            <div class="footer-workspace-mid-middle-text" [routerLink]="'/feedback'">-->
<!--              <app-texts-->
<!--                [texts]="[-->
<!--                {text: ['Связаться с нами', 'Contact us']}-->
<!--              ]"-->
<!--              />-->
<!--            </div>-->
          </div>
          <img [src]="getImg()" [style]="footerService.getFooterStyle()" alt="img" style="filter: brightness(0.95);;">
        </div>
        <div class="footer-workspace-mid-right col-3 footer-middle-text" style="padding-left: 5vw">
          <div class="footer-font footer-link" (click)="openTelegram($event)">
            Telegram
          </div>
          <div class="footer-font footer-link" style="padding: 23px 0" (click)="openInstagramProfile($event)">
            Instagram
          </div>
          <div class="footer-font footer-link" (click)="openWhatsApp($event)">
            WhatsApp
          </div>
        </div>
      </div>
      <div class="footer-workspace-bot">
        <div class="footer-font footer-wrap col-3 bot-left" *ngIf="!mob">
          {{ '2026 © ' + text(['First Class Solutions Limited', 'First Class Solutions Limited']) }}
        </div>
        <div class="footer-font col-6 bot-mid" [style]="'justify-content: center;'" *ngIf="!mob">

          {{ 'BR № 77889104' }}
        </div>
        <div class="footer-font col-3 bot-right" [style]="'padding-left: 5vw'" *ngIf="!mob">
            <span (click)="multiOpen(true, $event)">
              <app-texts
                [texts]="botRight"
              />
            </span>
        </div>
        <div class="mob-bot" *ngIf="mob">
          <div class="mob-bot-el">
            <app-texts (click)="openPdfInNewTab('cookie')" [texts]="[
              {text: ['Cookie Policy', 'Cookie Policy']}
            ]"/>
            <span> | </span>
            <app-texts (click)="openPdfInNewTab('privacy')" [texts]="[
              {text: ['Privacy Policy', 'Privacy Policy']}
            ]"/>
            <span> | </span>
            <app-texts (click)="openPdfInNewTab('public')" [texts]="[
              {text: ['Public Offer', 'Public Offer']}
            ]"/>
          </div>
<!--          <div class="mob-bot-el" style="margin-top: 4px">-->
<!--            <app-texts [texts]="[-->
<!--              {text: ['2026 © First Class Solutions Limited', '2026 © First Class Solutions Limited']}-->
<!--            ]"/>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
